import { Email } from './../../../model/cadastro/email.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NetworkService } from "../../../services/network.service";
import { UsuarioWeb } from '../../../model/usuario-web/usuario-web.model';
import { ActivatedRoute, Router } from "@angular/router";
import { getUrlImplante } from "../../../controller/staticValues";
import { MessageService } from "primeng/api";
import { Subscription } from 'rxjs'
import { Formulario } from "../../../controller/Formulario";
import { DadosDefaultService } from "../../../services/dados-default.service";
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Util } from 'src/app/controller/Util';


@Component({
    selector: 'app-email-cadastro',
    templateUrl: './email-cadastro.component.html',
    styleUrls: ['./email-cadastro.component.css'],
    standalone: false
})
export class EmailCadastroComponent implements OnInit {

  //   email: string;
  // text: string;

  entObj = new Email()
  public lista: any[] = []
  form: UntypedFormGroup;
  usuario: any;
  id: any;

  modalVisible = true

  constructor(private fb: UntypedFormBuilder, public route: ActivatedRoute, private networkService: NetworkService, private router: Router, private messageService: MessageService, private dadosDefaultService: DadosDefaultService) {
    this.form = Formulario.createForm(this.entObj, this.fb);
    this.form.get('DataEnvio')?.setValue(new Date)
  }

  ngOnInit() {

  }

  salvarEmail() {
    const email = { ...Formulario.parseForm(new Email(), Object.assign(this.form.value), undefined, undefined, Email.datas(), undefined, Email.checkbox())};
    this.networkService.exibirLoader.next(true)
    this.networkService.salvarPost(getUrlImplante(), 'adm/GravarEmail', email).subscribe(value => {
      this.router.navigate(['email'])
    }, error1 => {
        this.messageService.add(Util.pushErrorMsg(error1))
    }).add(() => this.networkService.exibirLoader.next(false));
  }

  cancelar() {
    this.router.navigate(['email']);
  }
}
